import React, { useMemo, useContext, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';
import useDetailFetch from '../../../../hooks/useDetailFetch';

const ReminderDetails = () => {
  const { reminderId } = useParams();
  const navigate = useNavigate();
  const { showToast } = useContext(ToastContext);
  const [showDelete, setShowDelete] = useState(false);

  const decodedId = reminderId ? atob(reminderId) : reminderId;
  const id = decodedId ? decodedId.replace(/\D/g, '') : '';

  const url = id ? `${API_DOMAIN}${API_ROUTES.customerReminder}${id}/` : null;
  const { data: reminder, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!reminder) return [];
    const excluded = ['id', 'created_at', 'updated_at'];
    return Object.keys(reminder)
      .filter(k => !excluded.includes(k))
      .map(k => ({ label: k.charAt(0).toUpperCase() + k.slice(1).replace(/_/g, ' '), field: k }));
  }, [reminder]);

  const handleDelete = async () => {
    try {
      await axios.delete(`${API_DOMAIN}${API_ROUTES.customerReminder}${id}/`);
      showToast('Reminder deleted successfully', 'success');
      navigate('/customer/reminder/list');
    } catch (error) {
      showToast('Error deleting reminder', 'error');
      console.error('Error deleting reminder:', error);
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={reminder}
        columns={columns}
        loading={loading}
        entityName="Reminder"
        listPath="/customer/reminder/list"
        editPath={`/customer/reminder/input/${btoa(String(id))}`}
        onDelete={() => setShowDelete(true)}
      />
      <ConfirmModal
        show={showDelete}
        title="Delete Reminder"
        message="Are you sure you want to delete this reminder?"
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
      />
    </div>
  );
};

export default ReminderDetails;
